import { useDispatch } from "react-redux";
import { API_OPTIONS } from "../utils/constants";
import { addUpcomingMovies } from "../utils/moviesSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const useUpcomingMovies = () => {
const dispatch = useDispatch();
//memoization
const upcomingMovies = useSelector(store => store.movies.upcomingMoviesMovies)

const getUpcomingMovies = async () => {
  const data = await fetch('https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1', API_OPTIONS);
  const json = await data.json();
 
  dispatch(addUpcomingMovies(json.results));
}



useEffect(()=>{
 if(!upcomingMovies) getUpcomingMovies();
},[]);
}

export default useUpcomingMovies;


